// Force redeploy: trigger CI pipeline after GitHub Actions outage on 2026-05-26.
enum UserRole {
    Admin = 'admin',
    Manager = 'manager',
    User = 'user',
    Viewer = 'viewer'
}

const TableResultsPerPage = [12, 24, 36, 48];

const statusColorMap = {
    active: 'green',
    success: 'green',
    enabled: 'green',
    succeeded: 'green',
    connected: 'green',
    completed: 'green',
    on: 'green',
    pending: 'blue',
    'pending-renewal': 'yellow',
    cart: 'yellow',
    unassigned: 'yellow',
    cancelled: 'red',
    suspended: 'red',
    disabled: 'red',
    rejected: 'red',
    inactive: 'red',
    off: 'red',
    failed: 'red',
    inventory: 'gray',
    draft: 'gray',
    reserved: 'porto',
    published: 'porto',
    'pending-approval': 'porto',
    'pending-cancellation': 'yellow',
    cancelling: 'yellow',
    blocked: 'yellow',
    shipped: 'blue',
    'pending-shipment': 'blue',
    confirmed: 'blue',
    queued: 'yellow',
    quote: 'yellow',
    'rejected-quote': 'red',
    'partial-refund': 'yellow',
    refunded: 'red',
    archived: 'yellow',
    'on-hold': 'yellow',
    trash: 'red',
    replaced: 'yellow',
    'auto-approved': 'blue',
    new: 'yellow',
    approved: 'green',
}
export { UserRole, TableResultsPerPage, statusColorMap }
export * from './shipment-stop-role-visual'
export * from './battery'
export * from './notify-groups'
export * from './scout-ai-models'